/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';


$(document).ready(function () {
    createProductSpin();
    createInputFile();
    coverImage();
    imageScrollBox();

    prestashop.on('updatedProduct', function (event) {
        createInputFile();
        coverImage();

        if (event && event.product_minimal_quantity) {
            const minimalProductQuantity = parseInt(event.product_minimal_quantity, 10);
            const quantityInputSelector = '#quantity_wanted';
            let quantityInput = $(quantityInputSelector);

            // @see http://www.virtuosoft.eu/code/bootstrap-touchspin/ about Bootstrap TouchSpin
            quantityInput.trigger('touchspin.updatesettings', {min: minimalProductQuantity});
        }
        imageScrollBox();
        $($('.tabs .nav-link.active').attr('href')).addClass('active').removeClass('fade');
        $('.js-product-images-modal').replaceWith(event.product_images_modal);
    });

    function coverImage() {
        $('.js-thumb').on(
            'click',
            (event) => {
                $('.js-modal-product-cover').attr('src',$(event.target).data('image-large-src'));
                $('.selected').removeClass('selected');
                $(event.target).addClass('selected');
                $('.js-qv-product-cover').prop('src', $(event.currentTarget).data('image-large-src'));
            }
        );
    }

    function imageScrollBox()
    {
        if ($('#main .js-qv-product-images li').length > 2) {
            $('#main .js-qv-mask').addClass('scroll');
            $('.scroll-box-arrows').addClass('scroll');
            $('#main .js-qv-mask').scrollbox({
                direction: 'h',
                distance: 113,
                autoPlay: false
            });
            $('.scroll-box-arrows .left').click(function () {
                $('#main .js-qv-mask').trigger('backward');
            });
            $('.scroll-box-arrows .right').click(function () {
                $('#main .js-qv-mask').trigger('forward');
            });
        } else {
            $('#main .js-qv-mask').removeClass('scroll');
            $('.scroll-box-arrows').removeClass('scroll');
        }
    }

    function createInputFile()
    {
        $('.js-file-input').on('change', (event) => {
            let target, file;

            if ((target = $(event.currentTarget)[0]) && (file = target.files[0])) {
                $(target).prev().text(file.name);
            }
        });
    }

    function changeAccordianoEnable(){
        var nextIsExpanded=false;
        $('.product-variants #accordionProductVariants .card').each(function(){
            if($(this).find('.show.collapse').hasClass('in')){
                $(this).find('.show.collapse').removeClass('in').attr('aria-expanded','false');
                nextIsExpanded=true;
            } else {
                if (nextIsExpanded){
                    $(this).find('.show.collapse').addClass('in').attr('aria-expanded','true');
                    nextIsExpanded=false;
                }
            }
        });
    }

    function createProductSpin()
    {
        let quantityInput = $('#quantity_wanted');

        quantityInput.TouchSpin({
            verticalbuttons: true,
            verticalupclass: 'material-icons touchspin-up',
            verticaldownclass: 'material-icons touchspin-down',
            buttondown_class: 'btn btn-touchspin js-touchspin',
            buttonup_class: 'btn btn-touchspin js-touchspin',
            min: parseInt(quantityInput.attr('min'), 10),
            max: 1000000
        });

        quantityInput.on('change', function (event) {
            let $productRefresh = $('.product-refresh');
            $(event.currentTarget).trigger('touchspin.stopspin');
            $productRefresh.trigger('click', {eventType: 'updatedProductQuantity'});
            event.preventDefault();

            return false;
        });
    }

    $(function(){
       $(document).on("click", ":submit", function(e){
           if ($(this).val()==='upload image' || $(this).val()==='subir imagen') {
               e.preventDefault();
               var apple=0;
               var id=$('#product_page_product_id').val();
               var token = prestashop.static_token; //important for logged user
               var formData = new FormData(document.getElementById('add-to-cart-or-refresh'));
               $.ajax({
                   url: "index.php?controller=product&id_product="+id+"&token="+token+"&ajax=true&action=uploadImageToMarcaje",
                   type: 'POST',
                   dataType: "json",
                   data: formData,
                   contentType: false,
                   processData: false,
                   success: function (jsonData) {
                       $("input[name='imageTomarcajeURL']").val(jsonData.imageurl);
                       var imageUrl="/img"+jsonData.imageurl;
                       $("#vista_imagen_marcaje").attr("src",imageUrl);
                       $(".bloque-imagen-marcaje").removeClass('hidden');
                   }
               });
           }
       });
    });


    $('.js-thumb').click(function(){
       var src=$(this).attr('src');
        $('.js-modal-product-cover').attr('src',$(this).data('image-large-src'));
        $('.selected').removeClass('selected');
        $(this).addClass('selected');
        $('.js-qv-product-cover').prop('src',src.replace("small_default", "large_default"));
    });

    $('#virtual_box_product_quantity').click(function(){

        $(this).parent('li').children('input[name="virtual_product_quantity"]').trigger("click");
    });

    $('#virtual_box_product_quantity').change(function(){
        //$('#quantity_wanted').val($(this).val());
        $('#quantity_wanted').val($(this).val(10));
        $(this).parent('li').find('input[name="virtual_product_quantity"]').val($(this).val());
        $(this).parent('li').find('input[name="virtual_product_quantity"]').trigger("click");
        changeAccordianoEnable();
    });

    $('.card .card-body .custom-radio input, .card .card-body .custom-radio .inputValue').click(function(){
       if (!$(this).hasClass('not-disable-accordion')){
            changeAccordianoEnable();
        }
    });

    $("input[name='virtual_product_quantity']").click(function () {


        $('#quantity_wanted').val($("input[name='virtual_product_quantity']:checked").val());
        $('#virtual_box_product_quantity').val($("input[name='virtual_product_quantity']:checked").val());
    });

    $('#product_accessories').owlCarousel({
        loop:false,
        rewind: true,
        margin:15,
        //stagePadding: 50,
        nav:true,
        responsiveClass:true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
            1000:{
                items:3
            },
            1200:{
                items:4
            }
        },
        dots: false,
        navText: ['<i class="material-icons md48">navigate_before</i>','<i class="material-icons md48">navigate_next</i>']
    })

    $('#accordionProductVariants li input').on("click", bindfunction);
});

function bindfunction(e) {
    var atributte='';
    $('.card').each(function(){
        atributte+='&atribute['+$(this).find(".card-header").attr('id')+']='+($(this).find("input:checked").val());
    });
    var actionURL = '/index.php';
    var token = prestashop.static_token; //important for logged user
    var id=$('#product_page_product_id').val();
    var query= 'controller=product&action=selectAttribute&ajax=true&token='+token+'&id_product='+ id+atributte;

    $.post(actionURL, query, null, 'json').then(function (resp) {
        prestashop.emit('selectAttribute', {
            reason: resp
        });
        if (resp.uploadImageAvailable){
            if ($('#uploadImage').hasClass('hidden'))
                $('#uploadImage').removeClass('hidden').show();
        } else {
            if (!$('#uploadImage').hasClass('hidden'))
                $('#uploadImage').addClass('hidden').hide();
        }
        // {category:/}{id}{-:id_product_attribute}-{rewrite}{-:ean13}.html

        // http://ediprem.servidor.gal/es/deportes/21-1147-polo-hombre-slazenger-backhand#/1-tama%C3%B1o-s/16-color-amarillo/91-marcaje-sin_marcaje/97-tipo_de_marcaje-serigraf%C3%ADa_s
        // http://ediprem.servidor.gal/es/deportes/21-1147-polo-hombre-slazenger-backhand#/1-tama%C3%B1o-s/16-color-amarillo/91-marcaje-sin_marcaje/97-tipo_de_marcaje-serigraf%C3%ADa_s

        if (resp.error!=null){
            $('.add-to-cart').attr('disabled','disabled');
            $('#product-availability').text(resp.error);
        } else {
            $('.add-to-cart').removeAttr("disabled");
            
            $('#product-availability').text('');
        }

        if (resp.combinationImageLink!=null) 
            $('.js-qv-product-cover').prop('src',"http://"+resp.combinationImageLink);
        $('#virtual_product_quantity li').each(function(){
            if ($(this).find('input').val() > parseInt(resp.stockToCombination) && resp.disabledItems ){
                $(this).find('input').attr('disabled','disabled');
            } else {
                $(this).find('input').removeAttr('disbaled');
            }
        });
        $('#virtual_box_product_quantity').attr('max',resp.stockToCombination);
        $('#unit_product_price').find('strong').text((Math.round(resp.newPrice * 100) / 100).toLocaleString('es-ES') + ' €');
        // $('.current-price').find('span').text(Math.round(resp.newPrice*100)/100+' €')
        // $('.current-price').find('span').attr('content',Math.round(resp.newPrice*100)/100)
        $('#total_price').find('strong').text((Math.round(parseFloat(resp.newPrice * parseInt($('#quantity_wanted').val())) * 100) / 100).toLocaleString('es-ES') + ' €');
    }).fail(function (resp) {
        prestashop.emit('handleError', { eventType: 'selectAttribute', resp: resp });
    });
    var html = $(this).parents('label').children('span.inputValue').text() + '<i class="material-icons">done</i>';
    $(this).parents('.card').find('.group-value-selected').html(html);


}

export{bindfunction};




// WEBPACK FOOTER //
// ./js/product.js